import { render, staticRenderFns } from "./SearchUser.vue?vue&type=template&id=470db094&"
import script from "./SearchUser.vue?vue&type=script&lang=ts&"
export * from "./SearchUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports